import { render, staticRenderFns } from "./CompanyOverviewPanel.vue?vue&type=template&id=0b7e9543&scoped=true"
import script from "./CompanyOverviewPanel.vue?vue&type=script&lang=js"
export * from "./CompanyOverviewPanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyOverviewPanel.vue?vue&type=style&index=0&id=0b7e9543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e9543",
  null
  
)

export default component.exports